export const environment = {
  production: false,
  hmr       : false,
  version: require('../../package.json').version,
  coursesApiUrl: 'https://dev-crud.spaces.wondavr.com',
  coursesSocketUrl: 'wss://dev-crud.spaces.wondavr.com/websocket',
  assetManagerUrl: 'https://dev-assets-manager.spaces.wondavr.com',
  contentBucketPrefix: 'https://dev-content.spaces.wondavr.com',
  assetsBucketPrefix: 'https://dev-assets.spaces.wondavr.com',
  analyticsServiceUrl: 'https://dev-analytics.spaces.wondavr.com',
  generateSubtitleTrigger: 'https://europe-west1-dev-spaces.cloudfunctions.net/dev-spaces-generateTranscriptionSubtitle',
  templateFile: 'https://dev-assets.spaces.wondavr.com/templates/templates.json',
  simulationsTemplateFile: 'https://dev-assets.spaces.wondavr.com/templates/simulations_templates.json',
  programsTemplateFile: 'https://dev-assets.spaces.wondavr.com/templates/programs_templates.json',
  voiceSelectionFile: `https://dev-assets.spaces.wondavr.com/voice-config/tts-voices-config.json`,
  languagePresetFile: `https://dev-assets.spaces.wondavr.com/languages/language-preset.json`,
  latestUseCaseFile:`https://eu-assets.spaces.wondavr.com/use-cases/latest-use-cases.json`,
  fromTheCommunityListFile:`https://dev-assets.spaces.wondavr.com/from-the-community/from-the-community.json`, // TODO: Generate DEV file on the model of templates
  cookieSubdomain: '.wondavr.com',
  proUrl: 'https://dev-pro.wondavr.com',
  labsUrl: 'https://dev-spaces.wondavr.com',
  firebase: {
    apiKey: 'AIzaSyA5X0cKNunvgUlPm085Cr_uJvVEhPLhtIU',
    authDomain: 'dev-spaces.firebaseapp.com',
    databaseURL: 'https://dev-spaces.firebaseio.com',
    projectId: 'dev-spaces', 
    storageBucket: 'dev-spaces.appspot.com',
    messagingSenderId: '851772332292'
  },
  quizDefaultImageId: '772e88d0-e103-11e8-b9a1-2d3ebd9be4e9',
  intercom_app_id: '',
  heap_id: '',
  googleTagManager: '',
  welcomeMessageUrl: 'https://wondavr.com/welcome/welcome.html',
  imlabHubId: 'e6f02ee0-7883-11e9-b100-e5591d5740a0',
  googleAnalyticsFlowId: 'G-531PGCPKKC',
  stripePublishableKey: 'pk_test_51RurBlBZB70Grc3Vglakym5ePaLpHEcZdQ3IWCKTj8MrjORhoqAz0u34OlSLOVj8N1TsonJHp1dn2fP06GHBqIBK00rXV8mZEa',
};
